// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"3e5ae708","75":"f46c198c","116":"386021bd"}[chunkId] + ".chunk.js";
};